var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_143_1975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6971 27.2079C32.1768 26.3116 31.4033 23.7757 31.4033 20.4635C31.4033 18.4744 30.6132 16.5667 29.2066 15.1602C27.8001 13.7537 25.8925 12.9635 23.9033 12.9635C21.9142 12.9635 20.0066 13.7537 18.6 15.1602C17.1935 16.5667 16.4033 18.4744 16.4033 20.4635C16.4033 23.7766 15.629 26.3116 15.1086 27.2079C14.9758 27.4357 14.9053 27.6946 14.9044 27.9584C14.9035 28.2221 14.9722 28.4815 15.1035 28.7102C15.2348 28.939 15.4241 29.1291 15.6523 29.2613C15.8805 29.3936 16.1396 29.4633 16.4033 29.4635H20.2293C20.4023 30.3102 20.8625 31.0712 21.532 31.6177C22.2014 32.1642 23.0391 32.4627 23.9033 32.4627C24.7675 32.4627 25.6052 32.1642 26.2747 31.6177C26.9442 31.0712 27.4044 30.3102 27.5774 29.4635H31.4033C31.667 29.4631 31.926 29.3933 32.154 29.261C32.3821 29.1286 32.5713 28.9385 32.7025 28.7098C32.8337 28.4811 32.9022 28.2218 32.9013 27.9581C32.9004 27.6944 32.8299 27.4357 32.6971 27.2079ZM23.9033 30.9635C23.4382 30.9634 22.9845 30.819 22.6047 30.5504C22.2249 30.2818 21.9378 29.9021 21.7827 29.4635H26.024C25.8689 29.9021 25.5817 30.2818 25.202 30.5504C24.8222 30.819 24.3685 30.9634 23.9033 30.9635ZM16.4033 27.9635C17.1252 26.7223 17.9033 23.846 17.9033 20.4635C17.9033 18.8722 18.5355 17.3461 19.6607 16.2209C20.7859 15.0956 22.312 14.4635 23.9033 14.4635C25.4946 14.4635 27.0208 15.0956 28.146 16.2209C29.2712 17.3461 29.9033 18.8722 29.9033 20.4635C29.9033 23.8432 30.6796 26.7194 31.4033 27.9635H16.4033Z",
    fill: "#1F2933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_143_1975",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_1975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_1975",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b5959b3e3c30846f7b8ff643b703d082.svg";
export { ForwardRef as ReactComponent };